import React, { useState } from "react";

import Checkbox from "@mui/material/Checkbox";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";
import { IconButton, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import ContrastIcon from "@mui/icons-material/Contrast";

import CheckboxChildrenList from "./CheckboxChildrenList";
import TransparencySlider from "./TransparencySlider";
import LayerInfo from "./LayerInfo";

export default function CheckboxListWithParent({
  checked,
  setChecked,
  parentCheckboxLabel,
  initialCollapseOpen = true,
  shortDescription,
  longDescription,
  offset,
  setOffset,
}) {
  const [collapseOpen, setCollapseOpen] = useState(initialCollapseOpen);

  const handleChange = (event, id) => {
    setChecked((currentCheckedState) => {
      currentCheckedState[id].visible = event.target.checked;

      return { ...currentCheckedState };
    });
  };

  const handleParentClick = (event) => {
    setChecked((currentCheckedState) => {
      Object.keys(currentCheckedState).forEach(
        (id) => (currentCheckedState[id].visible = event.target.checked)
      );
      return { ...currentCheckedState };
    });
  };

  if (!checked || Object.keys(checked) < 1) {
    return null;
  }

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "flex-start",
        }}
      >
        <Checkbox
          sx={{ p: 1 }}
          icon={<CircleOutlinedIcon />}
          checkedIcon={<CircleIcon />}
          indeterminateIcon={<ContrastIcon />}
          checked={Object.values(checked).every(({ visible }) => visible)}
          indeterminate={
            !Object.values(checked).every(({ visible }) => visible) &&
            Object.values(checked).some(({ visible }) => visible)
          }
          onChange={handleParentClick}
        />
        <Typography
          sx={{ cursor: "pointer" }}
          onClick={() => setCollapseOpen(!collapseOpen)}
        >
          {parentCheckboxLabel}
        </Typography>
        <LayerInfo
          shortDescription={shortDescription}
          longDescription={longDescription}
          longDescriptionTitle={parentCheckboxLabel}
        />
        <IconButton onClick={() => setCollapseOpen(!collapseOpen)}>
          {collapseOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={collapseOpen}>
        <CheckboxChildrenList
          checked={checked}
          handleChange={handleChange}
          sx={{ ml: 3 }}
        />
        {typeof offset === "number" && (
          <TransparencySlider offset={offset} setOffset={setOffset} />
        )}
      </Collapse>
    </div>
  );
}
